import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import app from './app'
import i18n from './locales'
import router from './router'
import store from './store'
import logger from './logger'
import filters from './filters'
import VeeValidate from 'vee-validate'
import Paginate from 'vuejs-paginate'
import VueMask from 'v-mask'

Vue.config.productionTip = false

// error handler -> https://vuejs.org/v2/api/#errorHandler
Vue.config.errorHandler = logger

// filters
Object.keys(filters).forEach((filter) => {
  Object.keys(filters[filter]).forEach((f) => {
    Vue.filter(f, filters[filter][f])
  })
})

// form validation
Vue.use(VeeValidate)

// pagination
Vue.component('paginate', Paginate)

// masked inputs
Vue.use(VueMask)

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(app)
})

Vue.directive('ctk-tooltip', {
  bind: function (el, binding) {
    el.addEventListener('mouseenter', function () {
      var $tooltip = document.createElement('div')
      var $tooltipDimension = el.getBoundingClientRect()
      var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
      $tooltip.setAttribute('class', 'ctk-tooltip')
      $tooltip.setAttribute('id', 'CtkTooltip')
      $tooltip.innerHTML = binding.value
      $tooltip.style.left = $tooltipDimension.left + ($tooltipDimension.width / 2) + 'px'
      $tooltip.style.top = top - 30 + 'px'
      document.body.appendChild($tooltip)
    })
    el.addEventListener('mouseleave', function () {
      var elemToRemove = document.getElementById('CtkTooltip')
      elemToRemove.parentNode.removeChild(elemToRemove)
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js